import { API_URL } from "../config";

interface LoginCredentials {
  email: string;
  password: string;
}

interface RegisterData extends LoginCredentials {
  name: string;
  invitationCode: string;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<string> {
    try {
      console.log('Enviando petición de login...');
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });

      const data = await response.json();
      console.log('Respuesta del servidor:', data);

      if (!response.ok) {
        throw new Error(data.message || 'Error al iniciar sesión');
      }

      if (!data.token) {
        throw new Error('No se recibió el token de autenticación');
      }

      return data.token;
    } catch (error) {
      console.error('Login error:', error);
      throw error instanceof Error ? error : new Error('Error desconocido en el login');
    }
  },

  async register(data: RegisterData) {
    try {
      const response = await fetch(`${API_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Registration failed");
      }

      return await response.json();
    } catch (error) {
      console.error("Registration error:", error);
      throw error instanceof Error ? error : new Error('Error desconocido en el registro');
    }
  }
};